"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsMobileResolution = void 0;
const useResolutionBreakpointsMap_1 = require("root/src/client/v2/browser/hooks/useResolutionBreakpointsMap");
function useIsMobileResolution() {
    const { resolutionBreakpointsMap } = (0, useResolutionBreakpointsMap_1.useResolutionBreakpointsMap)();
    const isMobileResolution = !resolutionBreakpointsMap.gtSm;
    return {
        isMobileResolution,
    };
}
exports.useIsMobileResolution = useIsMobileResolution;
